import React, { useState, useEffect } from 'react';
import { stateService, countryService } from '../../services/api';
import './AdminPage.css';

function AdminState() {
  const [states, setStates] = useState([]);
  const [countries, setCountries] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingState, setEditingState] = useState(null);
  const [formData, setFormData] = useState({
    Name: '',
    CountryId: ''
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadData();
    loadDropdowns();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const data = await stateService.getStates();
      setStates(data);
    } catch (error) {
      alert('Error loading states: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const loadDropdowns = async () => {
    try {
      const data = await countryService.getCountries();
      setCountries(data);
    } catch (error) {
      console.error('Error loading dropdowns:', error);
    }
  };

  const handleAdd = () => {
    setEditingState(null);
    setFormData({ Name: '', CountryId: '' });
    setIsModalOpen(true);
  };

  const handleEdit = (state) => {
    setEditingState(state);
    setFormData({
      Id: state.Id,
      Name: state.Name || '',
      CountryId: state.CountryId || ''
    });
    setIsModalOpen(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this state?')) {
      try {
        await stateService.deleteState(id);
        loadData();
      } catch (error) {
        alert('Error deleting state: ' + error.message);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await stateService.saveState(formData);
      setIsModalOpen(false);
      loadData();
    } catch (error) {
      alert('Error saving state: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-page">
      <div className="page-header page-headeradmin">
        <h1>State Management</h1>
        <button className="btn-primary" onClick={handleAdd}>Add State</button>
      </div>

      {loading && !states.length ? (
        <div className="loading">Loading...</div>
      ) : (
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Country</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {states.map((state) => (
                <tr key={state.Id}>
                  <td>{state.Name}</td>
                  <td>{state.Country?.Name}</td>
                  <td>
                    <button className="btn-edit" onClick={() => handleEdit(state)}>Edit</button>
                    <button className="btn-delete" onClick={() => handleDelete(state.Id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {isModalOpen && (
        <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editingState ? 'Edit State' : 'Add State'}</h2>
              <button className="modal-close" onClick={() => setIsModalOpen(false)}>×</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-grid">
                <div className="form-group">
                  <label>Name *</label>
                  <input
                    type="text"
                    value={formData.Name}
                    onChange={(e) => setFormData({ ...formData, Name: e.target.value })}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Country *</label>
                  <select
                    value={formData.CountryId}
                    onChange={(e) => setFormData({ ...formData, CountryId: e.target.value })}
                    required
                  >
                    <option value="">Select Country</option>
                    {countries.map((country) => (
                      <option key={country.Id} value={country.Id}>{country.Name}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn-secondary" onClick={() => setIsModalOpen(false)}>Cancel</button>
                <button type="submit" className="btn-primary" disabled={loading}>
                  {loading ? 'Saving...' : 'Save'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminState;

